import * as particles from "pixi-particles";
import { Graphics } from "pixi.js";
import particleManager from "slotworks/graphics/particles/particle-manager";
import Point from "slotworks/utils/geom/point";
import Layers from "slotworks/graphics/layers/layers";
import Timer from "slotworks/utils/timer";
import Contract from "slotworks/utils/contract";

export default class PotLandEmitterComponent {

    private emitters: Map<number, particles.Emitter>;

    potLandEmit(id:number, x: number, y: number) {
        if(!this.emitters) 
            this.emitters = new Map();
        if(!this.emitters.has(id)) {            
            const emitterId = particleManager.add("scatterLand", new Point(x, y), Layers.MatrixForeground.container);
            const emitter = particleManager.get(emitterId);
            this.emitters.set(id, emitter);
        }
        const currentEmitter = this.emitters.get(id);    
        setTimeout(() => {
            currentEmitter.updateSpawnPos(x, y);
            currentEmitter.emit = true;
            setTimeout(() => { currentEmitter.emit = false;}, 500 );
        }, 200);
    }

}